// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--main-layout-container {
  background: #000000;
  min-height: 100vh;
  width: 100%;
  position: relative;
}

.scl--app-fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.scl--outlet-main-container {
  background: #000000;
}

.scl--main-content-mid-style-container {
  background: #000000;
}`, "",{"version":3,"sources":["webpack://./src/layout-module/layout-configuration/outlet/css/outlet.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".scl--main-layout-container {\n  background: #000000;\n  min-height: 100vh;\n  width: 100%;\n  position: relative;\n}\n\n.scl--app-fixed-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n}\n\n.scl--outlet-main-container {\n  background: #000000;\n}\n\n.scl--main-content-mid-style-container {\n  background: #000000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
